var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RibbonGroupBase } from '../ribbon-interfaces';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
/**
 * Table of Contents group implementation for Insert tab
 * @private
 */
var TOCGroup = /** @class */ (function (_super) {
    __extends(TOCGroup, _super);
    function TOCGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the Ribbon items for Table of Contents group
     * @returns {RibbonGroupModel} - Table of Contents group model
     * @private
     */
    TOCGroup.prototype.getGroupModel = function () {
        return {
            header: this.localObj.getConstant('Table of Contents'),
            groupIconCss: 'e-icons e-de-ctnr-tableofcontent',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Table of Contents'),
            collections: [{
                    items: [{
                            type: 'Button',
                            keyTip: 'A',
                            buttonSettings: {
                                content: this.localObj.getConstant('Table of Contents'),
                                iconCss: 'e-icons e-de-ctnr-tableofcontent',
                                isToggle: false,
                                clicked: this.insertTableOfContentsHandler.bind(this)
                            },
                            id: this.ribbonId + '_toc',
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Provide an overview of your document by adding a table of contents')
                            }
                        }]
                }]
        };
    };
    TOCGroup.prototype.insertTableOfContentsHandler = function () {
        var _this = this;
        showSpinner(this.documentEditor.element);
        setTimeout(function () {
            _this.container.documentEditor.editorModule.insertTableOfContents();
            hideSpinner(_this.documentEditor.element);
        });
    };
    return TOCGroup;
}(RibbonGroupBase));
export { TOCGroup };
